module.exports = __webpack_public_path__ + "img/kate_macK211264.9531087e.jpg";